import { render, staticRenderFns } from "./lot-alerts.vue?vue&type=template&id=56d97e3c&scoped=true&lang=pug"
import script from "./lot-alerts.vue?vue&type=script&lang=js"
export * from "./lot-alerts.vue?vue&type=script&lang=js"
import style0 from "./lot-alerts.vue?vue&type=style&index=0&id=56d97e3c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d97e3c",
  null
  
)

export default component.exports